<template>
  <div v-if="item" class="grid gap-3 pl-2 pr-3 pb-3 break-words">
    <!-- {{ item }} -->
    <div class="flex justify-between items-start border-b pb-2">
      <div>
        <h6
          class="mb-0 text-[20px] font-medium font-roboto text-customYellow-100">
          Plan Amount
        </h6>
        <h4
          class="mb-0 text-[40px] font-bold font-roboto text-black-100">
          ${{ $helper.formatAmount(item.total_amount) }}<span
            class="text-[30px]">/{{
              item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
            }}</span>
        </h4>
      </div>
      <!-- <div class="flex items-center gap-2.5">
        <img :src="getStatusImage(item.status_slug)" alt="Approved Icon"
          class="w-[25px] h-[25px] object-contain">
      
      </div> -->

      <div class="flex items-center gap-2.5">
        <p v-if="item.status_slug == 'pending'"
          class="inline-block text-center py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#F39C12]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'approved'"
          class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'payment_failed'"
          class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#FE5000]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'rejected'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#FE5000]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'active'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#73B7E5] capitalize">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'cancelled'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E] capitalize">
          {{ item.status_text }}</p>
        <p v-else>-</p>
      </div>
      
    </div>
    <div class="flex justify-between items-center border-b pb-2">
      <div class="w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Sale Date
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ $helper.isEmpty(item.sale_date) ? '-' : $helper.formatDateTime(item.sale_date) }}
        </h4>
      </div>
      <div class="w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-lime-600">
          Activation Date
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{item.activation_date }}
        </h4>
      </div>
    </div>
    <div class="flex justify-between items-center border-b pb-2">
      <div class="w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          ID
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ item.id }}
        </h4>
      </div>
      <div class="w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Agreement ID
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ $helper.isEmpty(item.agreement_id) ? '-' : item.agreement_id }}
        </h4>
      </div>
      <!-- <div>
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Qty
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ item.quantity }}
        </h4>
      </div> -->
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Plan Name
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.plan_name) ? '-' : item.plan_name }}
      </h4>
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Consumer Name
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.consumer_name) ? '-' : item.consumer_name }}
      </h4>
    </div>
    <div class="flex justify-between items-center border-b pb-2">
      <div class="w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Phone Number
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ $helper.isEmpty(item.consumer_phone) ? '-' : $helper.formatPhoneNumber(item.consumer_phone) }}
        </h4>
      </div>
      <div class="hidden tablet:block w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Email
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ $helper.isEmpty(item.consumer_email) ? '-' : item.consumer_email }}
        </h4>
      </div>
    </div>


    <div class="flex justify-between items-center border-b pb-2">
      <div class="w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Next Payment Date
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ $helper.isEmpty(item.next_billing_date) ? '-' : $helper.formattedDate(item.next_billing_date) }}
        </h4>
      </div>
      <div class="hidden tablet:block w-1/2">
        <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
          Expiry date
        </h6>
        <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
          {{ $helper.isEmpty(item.expiry_date) ? '-' : item.expiry_date }}
        </h4>
      </div>
    </div>


    <div v-if="!$helper.isEmpty(item.cancelled_at)" class="border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Cancelled At
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-[#D7385E]">
        {{ $helper.formatDateTime(item.cancelled_at) }}
      </h4>
    </div>


    <div class="border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Payment Method
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.last_digits) ? '-' : `Card ending with ${item.last_digits}` }}
      </h4>
    </div>

    <div class="tablet:hidden border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Email
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.consumer_email) ? '-' : item.consumer_email }}
      </h4>
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Service Address
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.service_address) ? '-' : item.service_address }}
      </h4>
    </div>

    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 text-[16px] font-normal font-roboto text-customYellow-100">
        Billing Address
      </h6>
      <h4 class="mb-0 text-[18px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.billing_address) ? '-' : item.billing_address }}
      </h4>
    </div>
    <div v-if="false" class="flex justify-center items-center gap-3 mt-3">
      <!-- <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 !border-purple-400 text-purple-400 hover:bg-purple-400 hover:text-white">See
        Work History</span>
      <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 !border-purple-400 text-purple-400 hover:bg-purple-400 hover:text-white">See
        Commissions</span> -->
      <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 bg-gray-300 text-white">See
        Work History</span>
      <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 bg-gray-300 text-white">See
        Commissions</span>
    </div>
  </div>
</template>


<script>


export default {

  components: {

  },

  props: ["item"],
  data() {
    return {

    };
  },
  computed: {

  },

  watch: {

  },

  mounted() {

  },

  methods: {
    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
          case 'cancelled':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  },
};
</script>